import React, { FC, useState } from 'react';
import { Input } from 'antd';
import { Button } from '../../../../../../../components/Button/Button';
import { ReactComponent as NextIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg';
import './ProgramNameStep.scss';

interface ProgramNameStepProps {
  value?: string;
  onChange: (val: string) => void;
  onNext: () => void;
}

export const ProgramNameStep: FC<ProgramNameStepProps> = ({ value = '', onChange, onNext }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmed = e.target.value.trim();
    setLocalValue(trimmed);
    onChange(trimmed);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
    onChange(e.target.value);
  };

  const isValid = localValue.trim().length > 0;

  return (
    <div className="program-name-step">
      <h2 className="step-title">Let&apos;s give your workout a name</h2>

      <div className="input-container">
        <Input
          className="program-name-input"
          placeholder="Enter Workout Name"
          maxLength={100}
          value={localValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onPressEnter={() => {
            if (isValid) onNext();
          }}
        />
      </div>

      <div className="action-container">
        <Button
          variant="primary"
          className="next-btn right-arrow m-height-48 btn-primary-white"
          onClick={onNext}
          svg={<NextIcon />}
          disabled={!isValid}
        >
          <span style={{ color: '#000', fontWeight: 'bold' }}>Next</span>
        </Button>
      </div>
    </div>
  );
};
